export const loginUser = ( state, { user , token } ) => {
    if(token){
        localStorage.setItem('idToken', token)
        state.idToken = token
    }
    state.user = user
    state.status = true    
}